import {version} from '../package.json'

export const config = {
    mantainance: false,
    bundle: "com.your.bundle",
    version: version,
    refreshTokenAdvance: 300, //seconds before expire
    apiKey: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
    baseurl: "",
    defaultLanguage: { code: "it", label: "Italian" },
    languages: [
        { code: "gb", label: "English" },
        { code: "it", label: "Italian" },
    ],
    tab_channel: {
        device: "com.your.bundle/device",
        mainTab: "com.your.bundle/main-tab"
    },
    push_notification: {
        enabled: false,
        apiKey: "xxx",
        config: {  // WARNING: Remember to copy this params in /public/firebase-messaging-sw.js
            apiKey: "...",
            authDomain: "...",
            projectId: "...",
            storageBucket: "...",
            messagingSenderId: "...",
            appId: "...",
            measurementId: "..."
        }
    },
    restError: {
        BadRequest: "1000",
        PreconditionFailed: "6000",
        Forbidden: "8000",
    }
};